import styles from "./style.postcss";

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import {
  PageCard,
  Icon,
  Tooltip,
  moment,
  connect,
  Form,
  Grid,
  testClass,
} from "omni-common-ui";
import SkillSuggestionCard from "./SkillSuggestionCard";
import TipsAndUpdatesIcon from "./TipsAndUpdatesIcon";
import AddInternalNoteControl from "components/AddInternalNoteControl";
import UserCard from "components/UserCard";
import FeedbackTipsDialog from "./FeedbackTipsDialog";
import BottomButtons from "../BottomButtons";
import {
  actions as individualDevelopmentPlans,
  accessors as idpAccessors,
} from "data/IndividualDevelopmentPlans";
import is from "is_js";
import { List } from "immutable";
import classnames from "classnames";
import { Modes } from "../routes";
import ReactGA from "react-ga4";
import PropTypes from "prop-types";

const NUMBER_OF_TOTAL_SKILL_SUGGESTIONS = 3;

class FeedbackSuggestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wasCommentsEditMade: false,
      commentsPopup: {
        isOpen: false,
      },
    };

    this._onDiscardClick = this._onDiscardClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this._onParticipationChanged = this._onParticipationChanged.bind(this);
  }

  componentWillMount() {
    if (this.props.isInEditMode) {
      const {
        overallSuggestion,
        overallRecommendation,
        participationId,
        skillSuggestions,
      } = this.props.suggestionsInfo;
      this._onEditComments(
        overallSuggestion,
        participationId,
        skillSuggestions,
        overallRecommendation,
      );
    }
  }

  componentDidMount() {
    if (!is.function(this.props.onComponentMounted)) {
      return;
    }
    this.props.onComponentMounted(this);
  }

  wasCommentsEditMade() {
    return this.props.isInEditMode && this.state.wasCommentsEditMade;
  }

  setWasCommentsEditMade(wasCommentsEditMade) {
    if (this.state.wasCommentsEditMade === wasCommentsEditMade) return;
    this.setState({ wasCommentsEditMade });
  }

  _renderUserAndOverall() {
    const { teacherId, suggestedTime, timeZone } = this.props.suggestionsInfo;
    const isSimplified = this.props.suggestionsInfo.isSimplifiedTeacherFeedback;
    const wrapperClass =
      this.props.shouldShowSuggestions && !isSimplified
        ? classnames(
            styles.FeedbackSuggestions_overallWrapper,
            styles._overallBorderBottom,
          )
        : styles.FeedbackSuggestions_overallWrapper;
    const dateStr =
      is.existy(suggestedTime) && is.existy(timeZone)
        ? moment
            .parseZone(suggestedTime)
            .clone()
            .tz(timeZone)
            .format("YYYY-MM-DD")
        : "";
    return (
      <div className={wrapperClass}>
        {is.number(teacherId) && teacherId !== 0 && (
          <UserCard
            id={teacherId.toString()}
            dateStr={dateStr}
            className={styles.FeedbackSuggestions_userCard}
          />
        )}
        <div className={styles.FeedbackSuggestions_overall}>
          <div className={styles.FeedbackSuggestions_overall_heading}>
            Overall
          </div>
          {this._renderOverallContent()}
          {isSimplified ? (
            <div className={styles.FeedbackSuggestions_recommendationBlock}>
              <div className={styles.FeedbackSuggestions_overall_heading}>
                Recommendation
              </div>
              {this._renderRecommendationContent()}
            </div>
          ) : null}
          {this._renderParticipation()}
        </div>
      </div>
    );
  }

  _renderRecommendationContent() {
    if (!this.props.isInEditMode) {
      return (
        <p className={styles.FeedbackSuggestions_overall_content}>
          {this.props.suggestionsInfo.overallRecommendation || "–"}
        </p>
      );
    }
    const { overallRecommendation } = this.state;
    return (
      <AddInternalNoteControl
        text={overallRecommendation}
        isMissing={this._isAnyEmpty(
          overallRecommendation && overallRecommendation.trim(),
        )}
        maxCharacters={1320}
        onChange={(text) => this._onOverallRecommendationChanged(text)}
      />
    );
  }

  _onOverallRecommendationChanged(overallRecommendation) {
    this.setWasCommentsEditMade(true);
    this.setState({ overallRecommendation });
  }

  _renderParticipation() {
    if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) return;
    if (this.props.participationInfo.size === 0) return;
    const labelClasses = classnames(styles.FeedbackSuggestions_subTitle, {
      [styles.__grey]: !this.props.isInEditMode,
    });
    return (
      <div className={styles.FeedbackSuggestions_overall_participation}>
        <div className={labelClasses}>Participation</div>
        {this._renderParticipationContent()}
      </div>
    );
  }

  _renderParticipationContent() {
    if (this.props.isInEditMode) {
      const selectedParticipationId = this.state.participationId;
      const isMissing = this._isAnyEmpty(selectedParticipationId);
      const options = this.props.participationInfo
        .toList()
        .toJS()
        .map((option) => ({
          label: option.name,
          value: parseInt(option.id, 10),
        }));
      options.splice(0, 0, {
        label: " ",
        value: 0,
        className: styles.FeedbackSuggestions_select_option,
      });
      return (
        <Grid>
          <Grid.Group>
            <Grid.Item xs={12} sm={6} md={6}>
              <Form>
                <Form.Select
                  name="idp-participation"
                  className={isMissing && styles.missing}
                  options={options}
                  value={selectedParticipationId}
                  setValue={this._onParticipationChanged}
                  clearable={false}
                  searchable={false}
                />
              </Form>
            </Grid.Item>
          </Grid.Group>
        </Grid>
      );
    }

    const participationId = this.props.suggestionsInfo.participationId || 0;
    const participation = this.props.participationInfo.get(
      participationId.toString(),
    );
    const participationName = (participation && participation.name) || "–";
    return <div>{participationName}</div>;
  }

  _renderOverallContent() {
    if (!this.props.isInEditMode) {
      return (
        <p className={styles.FeedbackSuggestions_overall_content}>
          {this.props.suggestionsInfo.overallSuggestion || "–"}
        </p>
      );
    }
    const { overallSuggestion } = this.state;
    return (
      <AddInternalNoteControl
        text={overallSuggestion}
        isMissing={this._isAnyEmpty(
          overallSuggestion && overallSuggestion.trim(),
        )}
        maxCharacters={1320}
        onChange={(text) => this._onOverallSuggestionChanged(text)}
      />
    );
  }

  _onOverallSuggestionChanged(overallSuggestion) {
    this.setWasCommentsEditMade(true);
    this.setState({ overallSuggestion });
  }

  _onSkillSuggestionChanged(text, skillIndex) {
    this.setWasCommentsEditMade(true);
    const skillSuggestions = this.state.skillSuggestions.map(
      (skillSuggestion, index) => {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, { suggestion: text });
        }
        return skillSuggestion;
      },
    );
    this.setState({ skillSuggestions });
  }

  _onSkillRecommendationChanged(skillIndex, recommendations) {
    const skillSuggestions = this.state.skillSuggestions.map(
      (skillSuggestion, index) => {
        if (skillIndex === index) {
          return Object.assign({}, skillSuggestion, {
            selectedRecommendationList: recommendations,
          });
        }
        return skillSuggestion;
      },
    );
    this.setState({ skillSuggestions });
  }

  _onSkillChanged(skillIndex, skillId) {
    const skillSuggestions = this.state.skillSuggestions;
    const suggestion = skillSuggestions[skillIndex];
    if (!is.undefined(suggestion) && suggestion.skillId === skillId) {
      return;
    }

    let newSkillSuggestion;
    if (is.not.empty(skillId) && skillId !== 0) {
      newSkillSuggestion = {
        skillId,
        suggestion: "",
        isManuallyAdded: true,
        selectedRecommendationList: [],
      };
    } else {
      newSkillSuggestion = {
        skillId: 0,
        suggestion: "",
        isManuallyAdded: true,
        selectedRecommendationList: [],
      };
    }
    skillSuggestions[skillIndex] = newSkillSuggestion;
    this.setState({ skillSuggestions });
    this.setWasCommentsEditMade(true);
  }

  _onParticipationChanged(participationId) {
    this.setWasCommentsEditMade(true);
    this.setState({ participationId });
  }

  _renderSkillSuggestions() {
    if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) return;
    const {
      shouldShowSuggestions,
      suggestionsInfo: { skillSuggestions, skillResults },
      isInEditMode,
    } = this.props;
    if (!shouldShowSuggestions) return;
    const skillOptions = skillResults.toJS();
    const choosenSuggestions = isInEditMode
      ? new List(this.state.skillSuggestions)
      : skillSuggestions;
    let suggestionCards = choosenSuggestions.map((skillSuggestion, index) =>
      this._renderSkillSuggestionCard(
        skillSuggestion,
        index,
        skillOptions,
        choosenSuggestions
          .filter((_, idx) => idx !== index)
          .map((ss) => ss.skillId)
          .toJS(),
        skillSuggestion.selectedRecommendationList.size === 0,
      ),
    );
    const numberOfManual =
      NUMBER_OF_TOTAL_SKILL_SUGGESTIONS - suggestionCards.size;
    if (numberOfManual >= 1 && isInEditMode) {
      for (
        let index = suggestionCards.size;
        index < NUMBER_OF_TOTAL_SKILL_SUGGESTIONS;
        index++
      ) {
        suggestionCards = suggestionCards.concat(
          this._renderSkillSuggestionCard(
            undefined,
            index,
            skillOptions,
            choosenSuggestions.map((ss) => ss.skillId).toJS(),
          ),
        );
      }
    }
    return suggestionCards;
  }

  _renderSkillSuggestionCard(
    skillSuggestion,
    index,
    skillOptions,
    hiddenOptions = [],
    isMissing = false,
  ) {
    const {
      isInEditMode,
      isSSV3Group,
      isSkillSuggestionManualOnly,
      skillRecommendations,
    } = this.props;
    const wrapperClass = isInEditMode
      ? styles.FeedbackSuggestions_skillSuggestionWrapper
      : classnames(
          styles.FeedbackSuggestions_skillSuggestionWrapper,
          styles._borderTop,
        );
    const skillSuggestionText =
      skillSuggestion &&
      isInEditMode &&
      this.state.skillSuggestions[index].suggestion;
    const isManuallyAdded =
      !skillSuggestion || !!skillSuggestion.isManuallyAdded;
    return (
      <div key={index} className={wrapperClass}>
        <SkillSuggestionCard
          skillSuggestion={skillSuggestion}
          isInEditMode={isInEditMode}
          isSSV3Group={isSSV3Group}
          skillRecommendations={skillRecommendations}
          isMissing={isMissing}
          canEditSkillRecommandation={!isSkillSuggestionManualOnly}
          skillOptions={skillOptions}
          onSkillChanged={(skillId) => this._onSkillChanged(index, skillId)}
          onRecommendationChanged={(recommendations) =>
            this._onSkillRecommendationChanged(index, recommendations)
          }
          isManuallyAdded={isManuallyAdded}
          hiddenOptions={hiddenOptions}
          index={index}
        />
        {isInEditMode && (
          <div>
            {isSkillSuggestionManualOnly ? (
              <div className={styles.FeedbackSuggestions_subTitle}>
                Suggestions
              </div>
            ) : (
              <div className={styles.FeedbackSuggestions_subTitle}>
                Suggestions (optional)
              </div>
            )}
            <AddInternalNoteControl
              text={skillSuggestionText}
              maxCharacters={1320}
              isMissing={
                isSkillSuggestionManualOnly &&
                skillSuggestion &&
                skillSuggestion.skillId &&
                this._isAnyEmpty(
                  skillSuggestionText && skillSuggestionText.trim(),
                )
              }
              onChange={(text) => this._onSkillSuggestionChanged(text, index)}
              textAreaProps={{
                disabled:
                  is.not.existy(skillSuggestion) ||
                  skillSuggestion.skillId === 0,
                placeholder: "Type your own action plan here.",
              }}
              noAutoScroll
            />
          </div>
        )}
      </div>
    );
  }

  _onEditComments(
    overallSuggestion,
    participationId,
    skillSuggestions = [],
    overallRecommendation = "",
  ) {
    ReactGA.event({
      category: "IDP",
      action: 'Clicked "Edit" feedback and suggestions',
    });
    this.setState({
      overallSuggestion: overallSuggestion || "",
      overallRecommendation: overallRecommendation || "",
      participationId: participationId || 0,
      skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions),
    });
    this.props.changeMode(Modes.EDIT_COMMENTS);
  }

  _renderTipIcons() {
    return (
      <Tooltip
        text="Tips for giving overall feedback"
        placement="right"
        trigger={["hover"]}
        className={styles.FeedbackSuggestions_actionButton}
      >
        <TipsAndUpdatesIcon
          onClick={() =>
            this.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: false,
              },
            })
          }
        />
      </Tooltip>
    );
  }

  _renderActionIcons() {
    if (!this.props.canEdit) {
      return null;
    }
    return (
      <Tooltip
        text="Edit"
        placement="left"
        trigger={["hover"]}
        className={styles.FeedbackSuggestions_actionButton}
      >
        <Icon
          id="edit"
          className={testClass("edit")}
          onClick={() =>
            this.setState({
              commentsPopup: {
                isOpen: true,
                isOpenedbyEdit: true,
              },
            })
          }
        />
      </Tooltip>
    );
  }

  _onCommentsOKClick(isOpenedbyEdit) {
    const {
      overallSuggestion,
      overallRecommendation,
      participationId,
      skillSuggestions,
    } = this.props.suggestionsInfo;
    if (isOpenedbyEdit) {
      this._onEditComments(
        overallSuggestion,
        participationId,
        skillSuggestions,
        overallRecommendation,
      );
    }
    this.setState({
      commentsPopup: {
        isOpen: false,
      },
    });
  }

  _renderCommentsPopup() {
    const { commentsPopup } = this.state;
    return (
      <FeedbackTipsDialog
        isOpen={commentsPopup.isOpen}
        onOKClick={() => this._onCommentsOKClick(commentsPopup.isOpenedbyEdit)}
      >
        <h3>Tips for giving overall feedback and suggestion</h3>
        <div className={styles.FeedbackSuggestions_tipsContent}>
          <p className={styles.FeedbackSuggestions_tipsIntro}>
            These guiding principles are intended to help provide constructive
            feedback and suggestions to parents. Please address at least three of
            the points below concisely.
          </p>
          <ul className={styles.FeedbackSuggestions_tipsList}>
            <li>
              Give an example of a favourite activity or an area in which the
              student demonstrated strong performance during this period.
            </li>
            <li>
              Identify an area in which the student is experiencing difficulties,
              and provide a specific example.
            </li>
            <li>
              Explain what has been done, or will be done, in class to help the
              student improve in the identified area.
            </li>
            <li>
              Include any relevant comments or anecdotes about the student’s
              behaviour and participation in class.
            </li>
            <li>
              Mention any improvements made since the previous report or in
              response to concerns raised earlier, and explain how this progress has
              been achieved.
            </li>
          </ul>
        </div>
      </FeedbackTipsDialog>
    );
  }

  _getInitialSkillSuggestions(skillSuggestions) {
    return skillSuggestions.toJS().map((skillSuggestion) => ({
      skillId: skillSuggestion.skillId,
      suggestion: skillSuggestion.suggestion || "",
      isManuallyAdded: !!skillSuggestion.isManuallyAdded,
      selectedRecommendationList: skillSuggestion.selectedRecommendationList,
    }));
  }

  _onDiscardClick() {
    this.setWasCommentsEditMade(false);
    this.props.changeMode("");
  }

  onSaveClick() {
    if (this._isSaveDisabled()) return;
    if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) {
      this.props.submitIdpFeedbackSuggestions(
        this.props.idpId,
        {
          overallSuggestion: this.state.overallSuggestion || "",
          overallRecommendation: this.state.overallRecommendation || "",
        },
        this.props.groupIdpId,
      );
      this._onDiscardClick();
      return;
    }
    let skillSuggestions;
    if (this.props.shouldShowSuggestions) {
      skillSuggestions = this.state.skillSuggestions.filter(
        (skillSuggestion) =>
          is.not.empty(skillSuggestion) && skillSuggestion.skillId !== 0,
      );
    }
    const submittedSuggestions = {
      overallSuggestion: this.state.overallSuggestion || "",
      participationId: this.state.participationId,
      skillSuggestions,
    };
    this.props.submitIdpFeedbackSuggestions(
      this.props.idpId,
      submittedSuggestions,
      this.props.groupIdpId,
    );
    this._onDiscardClick();
  }

  _isSaveDisabled() {
    const { overallSuggestion, overallRecommendation } = this.state;
    const isOverallEmpty = !overallSuggestion || !overallSuggestion.trim();
    if (this.props.suggestionsInfo.isSimplifiedTeacherFeedback) {
      const isRecommendationEmpty =
        !overallRecommendation || !overallRecommendation.trim();
      return isOverallEmpty || isRecommendationEmpty;
    }
    return isOverallEmpty;
  }

  _renderSaveAndDiscardButtons() {
    if (!this.props.isInEditMode) return;
    return (
      <BottomButtons
        onSecondaryClick={this._onDiscardClick}
        onPrimaryClick={this.onSaveClick}
        primaryText="SAVE"
        secondaryText="DISCARD"
        isPrimaryDisabled={this._isSaveDisabled()}
      />
    );
  }

  _isAnyEmpty(...fields) {
    return fields.reduce(
      (previous, field) =>
        previous || is.falsy(field) || (is.existy(field) && is.empty(field)),
      false,
    );
  }

  _getEmptyHint(emptyActions) {
    let hint = "";
    if (emptyActions === 1) {
      hint = `${emptyActions} action is missing. Please edit the hightlighted field.`;
    } else if (emptyActions > 1) {
      hint = `${emptyActions} actions are missing. Please edit the hightlighted fields.`;
    }
    return hint;
  }

  render() {
    const {
      suggestionsInfo,
      shouldShowSuggestions,
      isSkillSuggestionManualOnly,
      canEdit,
    } = this.props;
    const emptyActions = idpAccessors.getEmptyActions(
      suggestionsInfo,
      shouldShowSuggestions,
      isSkillSuggestionManualOnly,
    );
    return (
      <PageCard>
        <PageCard.Heading className={styles.FeedbackSuggestions_heading}>
          <h1 className={styles.FeedbackSuggestions_headingTitle}>
            Teacher&apos;s feedback and suggestions
          </h1>
          <div className={styles.FeedbackSuggestions_tipButton}>
            {this._renderTipIcons()}
          </div>
          <div className={styles.FeedbackSuggestions_headingEnd}>
            {emptyActions && canEdit ? (
              <div className={styles.FeedbackSuggestions_header}>
                {this._getEmptyHint(emptyActions)}
              </div>
            ) : null}
            {this._renderActionIcons(this.props.suggestionsInfo)}
          </div>
        </PageCard.Heading>
        <PageCard.Content className={styles.FeedbackSuggestions_content}>
          {this._renderUserAndOverall()}
          {this._renderSkillSuggestions()}
          {this._renderSaveAndDiscardButtons()}
          {this._renderCommentsPopup()}
        </PageCard.Content>
      </PageCard>
    );
  }
}

FeedbackSuggestions.propTypes = {
  suggestionsInfo: PropTypes.shape().isRequired,
  participationInfo: PropTypes.shape().isRequired,
  isSSV3Group: PropTypes.bool,
  isSkillSuggestionManualOnly: PropTypes.bool,
  isInEditMode: PropTypes.bool.isRequired,
  changeMode: PropTypes.func.isRequired,
  submitIdpFeedbackSuggestions: PropTypes.func.isRequired,
  idpId: PropTypes.string.isRequired,
  groupIdpId: PropTypes.string.isRequired,
  onComponentMounted: PropTypes.func,
  canEdit: PropTypes.bool.isRequired,
  shouldShowSuggestions: PropTypes.bool.isRequired,
  skillRecommendations: PropTypes.shape(),
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(individualDevelopmentPlans, dispatch);
}

export default connect(null, mapDispatchToProps)(FeedbackSuggestions);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/index.jsx